import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { ProgressBar } from "@circle-react/components/Courses/ProgressBar";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const ProgressStatus = ({ course }) => {
  const { lessons_count: totalLessons } = course;

  const getProgress = ({ completedLessons, totalLessons }) => {
    if (totalLessons === 0) {
      return 0;
    }
    return Math.round((completedLessons / totalLessons) * 100);
  };

  const completedLessons = course.joined ? course.completed_lessons_count : 0;
  const progress = getProgress({ completedLessons, totalLessons });
  const isCourseCompleted = completedLessons === totalLessons;
  const percentageLabel = t("courses.directory.progress.completed");

  if (isCourseCompleted) {
    return (
      <div className="text-default flex items-center gap-x-1 pt-2">
        <Icon aria-hidden type="20-checkmark-circle" size={16} />
        <Typography.LabelSm weight="medium">
          {t("courses.directory.progress.completed")}
        </Typography.LabelSm>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-2 px-1 pt-2">
      <ProgressBar
        percentageLabel={percentageLabel}
        progress={progress}
        completedCount={completedLessons}
        totalCount={totalLessons}
      />
    </div>
  );
};

ProgressStatus.propTypes = {
  course: PropTypes.shape({
    joined: PropTypes.bool,
    completed_lessons_count: PropTypes.number,
    lessons_count: PropTypes.number,
  }).isRequired,
};
